module.exports = __webpack_public_path__ + "img/windows.1318c863.png";